import React, {useState} from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";


import '../../styles/style.scss';
import '../../styles/createContentStyle.scss';
import imageSliderService from '../../services/image-slider.service';
const IS_IMAGE = true
const validationSchema = Yup.object().shape({
  nameContent: Yup.string().required('Nombre del documento es requerido')
                  .matches(/^[A-zÀ-ú\d\-_\s]+$/i, "Solo se admiten letras y numero. No se admiten acentos."),
});
export const CreateImageScreen = (props) => {

  const fileUpdate = props.match.params.id;
  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [ file, setFile ] = useState(null);
  const [ fileName, setFileName ] = useState("");
  

  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });


  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });
 /**
   * Regresar al homePage
   * @param { string } response - respuesta  swalert
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const getReturnPage = (result) => {
    if (result.isConfirmed) {
      props.history.push('/');
        window.location.reload();
    }
  }

  /**
   * Realiza la cancelación de envio del formulario y regresa a la pagina de contenidos
   * @param { string } response - tipo de cancelación realizada
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const handleCancel = (response) => {

    let responseTitle = '';

    if(response === 'return'){
      responseTitle = 'Regresar';
    } else if(response === 'cancel'){
      responseTitle = 'Cancelar';
    }
    swalCustomButtons.fire({
      title: responseTitle,
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
        getReturnPage(result);
    })
  }
  /**
   * Recupera el archivo cargado
   * @param {*} target - recupera la información del imput de carga de archivo 
   * @returns 
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
  const onUploadFileChange = ({ target }) => {
    if (target.files < 1 || !target.validity.valid) {
      return
    }
    const file = target.files[0];    
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxDimension = 800; // Ajusta el tamaño máximo de la imagen

          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxDimension) {
              height *= maxDimension / width;
              width = maxDimension;
            }
          } else {
            if (height > maxDimension) {
              width *= maxDimension / height;
              height = maxDimension;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {

              setFile(blob);
            },
            'image/webp',
            0.7 // Ajusta la calidad de la imagen (0.7 es 70% de calidad)
          );
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
    
  };
  /**
   * Establece el nombre de la imagen a travez del TextField del formulario
   * @param {*} event - recupera información del imput seleccionado
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const handleChangeValue =(event) =>{

    setFileName(event.target.value)
  }

  /**
   * Envia la información del formulario del formulario para subir Imagenes
   * @param {*} data - datos del formulario
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
  
  const onSubmit = async () => {
    const optimizedFile = new File([file], fileName + ".jpeg", { type: 'image/webp' });
    setIsLoadingData(true)
    setIsLoadingForm(true)
    imageSliderService.uploadImage(optimizedFile,IS_IMAGE).then(()=>{
        swalCustomButtons.fire({
            title: "Operación Exitosa",
            text: "Se ha almacenado la imágen correctamente.",
            icon: 'success',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            reverseButtons: true
          }).then((result) => {
              getReturnPage(result);
          })
    }).catch((error)=>{
        setFile(null)
        setIsLoadingData(false);
        setIsLoadingForm(false)
        reset()
        if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          } else{
            actionErrorConnection(error, 
              (error.response && error.response.data) ?'No existen Secciones':'Error al recuperar secciones');
          }
    })
  };

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />
                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                      <div className="row">
                        <div className="col-10 text-title">
                          <span>Im&aacute;genes </span>
                          <i className="fas fa-angle-right ms-2 me-2"></i>
                         
                          <span>Nueva Im&aacute;gen</span>
                        </div>
                        <div className="col-2 text-title">
                          <div className="w-100 d-flex justify-content-end">
                            <Tooltip title="Regresar" placement="top-start" arrow>
                              <button className="btn custom-btn-icons" 
                              type="button" 
                              onClick={()=>handleCancel('return')}
                              >
                                <i className="fas fa-angle-left custom-icon-return"></i>
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>  
                    <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="container p-0">
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Información general</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                <div className="col-md-6 mt-2 mb-2">
                                <TextField
                                  required
                                  className="w-100"
                                  id="nameContent"
                                  name="nameContent"
                                  label="Nombre de la imágen"
                                  type="text"
                                  fullWidth
                                  variant="outlined"
                                  size="small"
                                  disabled={!!fileUpdate}
                                  {...register('nameContent')}
                                  error={!!errors.nameContent}
                                  value={fileName}
                                  onChange={handleChangeValue}
                                />
                                  <Typography variant="inherit" color="error">
                                      {errors.nameContent?.message}
                                  </Typography>
                                </div>
                              </div> 
                            </div>
                          </div>
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle">Cargar archivo</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5">
                              <div className="row">
                              <Tooltip title={fileName ? `Archivo cargado: ${fileName}`: 'No se ha cargado archivo'} placement="top-start" arrow>
                                <div className="col-md-12 mt-2 mb-2 input-group">

                                <input 
                                    type="file" 
                                    name="file" 
                                    id="file"
                                    className="form-control" 
                                    accept='.png,.jpg,.jpeg'
                                    onChange={onUploadFileChange}
                                      /> 
                                </div>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex flex-row-reverse ">
                            <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                              <button  
                              className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                              
                              disabled={ isLoadingForm || isLoadingData}>
                                <span className="me-2"> Agregar</span>
                                {
                                    isLoadingForm
                                    ? <i className="fas fa-spinner fa-spin"></i>
                                    : <i className="fas fa-save"></i>
                                } 
                              </button>
                              <button  
                              className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                              type="button" 
                              onClick={()=>handleCancel('cancel')}>
                                    Cancelar
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                      
                     
                    
                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}

CreateImageScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}
